<script lang="ts">
    import MediaSelector from '$backoffice/views/MediaManager/MediaSelector.svelte';

    export let inputName;
    export let value = '';
    export let required = false;
    export let apiEndpoint: string;
    export let mediaBaseUrl: string;
    export let focalPointInputName: string;
    export let imageWidthInputName: string;
    export let imageHeightInputName: string;
    export let cropProxyUrl: string;
</script>

<div class="form-control">
    <MediaSelector
        {inputName}
        {value}
        {required}
        {apiEndpoint}
        {mediaBaseUrl}
        {focalPointInputName}
        {imageWidthInputName}
        {imageHeightInputName}
        {cropProxyUrl}
    />
</div>
